import { render, staticRenderFns } from "./downApp.vue?vue&type=template&id=3bfac65a&scoped=true"
import script from "./downApp.vue?vue&type=script&lang=js"
export * from "./downApp.vue?vue&type=script&lang=js"
import style0 from "./downApp.vue?vue&type=style&index=0&id=3bfac65a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfac65a",
  null
  
)

export default component.exports